export default "__VITE_ASSET__B1D2EBAI__"